<template>
    <v-dialog v-model="show" max-width="600px" :persistent="loading" scrollable>
        <v-card class="pa-4">
            <v-card-title>
                Adicionar cliente
            </v-card-title>
            <v-card-text>
                <v-form ref="formCustomer">
                    <v-row>
                        <v-col cols="12">
                            <v-text-field v-model="email" :rules="[basic_rules.required, basic_rules.email]" label="Email" persistent-hint hint="Informe o email que o usuário usou para se registrar no aplicativo mobile" />
                        </v-col>
                    </v-row>
                    <v-row v-if="customer_checked">
                        <v-col v-if="error_message" cols="12">
                            <v-alert type="error darken-4">
                                {{ error_message }}
                            </v-alert>
                        </v-col>
                        <v-col v-if="alert_message" cols="12">
                            <v-alert type="warning">
                                {{ alert_message }}
                            </v-alert>
                        </v-col>
                        <v-col v-if="success_message" cols="12">
                            <v-alert type="success">
                                {{ success_message }}
                            </v-alert>
                        </v-col>
                        <v-col cols="12">
                            <v-row align="center">
                                <v-col>
                                    <v-divider></v-divider>
                                </v-col>
                                <v-col cols="auto">
                                    Informações do cliente
                                </v-col>
                                <v-col>
                                    <v-divider></v-divider>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="6">
                            <v-text-field v-model="name" label="Nome" :rules="[basic_rules.required]" :disabled="customer_checked && customer_data" />
                        </v-col>
                        <v-col cols="6">
                            <v-text-field-simplemask
                                v-model="cpf"
                                label="CPF"
                                :options="{
                                    inputMask: '###.###.###-##',
                                    outputMask: '###########',
                                    empty: null,
                                    applyAfter: false,
                                    alphanumeric: true,
                                    lowerCase: false,
                                }"
                                :properties="{
                                    disabled: customer_checked && customer_data,
                                }"
                            />
                        </v-col>
                        <v-col cols="6">
                            <v-text-field v-model="rg" :disabled="customer_checked && customer_data" label="RG" />
                        </v-col>
                        <v-col cols="6">
                            <v-text-field-simplemask
                                v-model="phone"
                                label="Telefone"
                                :options="{
                                    inputMask: '+## (##) #####-####',
                                    outputMask: '#############',
                                    empty: null,
                                    applyAfter: false,
                                    alphanumeric: true,
                                    lowerCase: false,
                                }"
                                :properties="{
                                    disabled: customer_checked && customer_data,
                                }"
                            />
                        </v-col>
                        <v-col cols="6">
                            <v-menu
                                ref="menuBirthPicker"
                                v-model="show_datepicker_birthday"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                                :disabled="customer_checked && customer_data"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        :value="formatDate(birthday)"
                                        label="Data de nascimento"
                                        append-icon="mdi-calendar"
                                        :disabled="customer_checked && customer_data"
                                        v-bind="attrs"
                                        v-on="on"
                                        @input="$event => birthday = formatUsa($event)"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="birthday"
                                    no-title
                                    scrollable
                                    editable
                                    :disabled="customer_checked && customer_data"
                                    @input="show_datepicker_birthday = false"
                                />
                            </v-menu>
                        </v-col>
                        <v-col cols="6">
                            <v-select
                                v-model="status"
                                label="Status do cliente"
                                :items="[
                                    { text: 'Primeiro contato', value: 'P' },
                                    { text: 'Cliente ativo', value: 'A' },
                                    { text: 'Cliente inativo', value: 'I' }
                                ]"
                                :rules="[basic_rules.required]"
                            />
                        </v-col>
                        <v-col cols="12">
                            <v-text-field-money
                                v-model="balance"
                                label="Saldo inicial"
                                :properties="{
                                    prefix: 'R$',
                                }"
                                :options="{
                                    locale: 'pt-BR',
                                    length: 11,
                                    precision: 2,
                                    empty: null,
                                }"
                            />
                        </v-col>
                        <v-col cols="12">
                            <v-row align="center">
                                <v-col>
                                    <v-divider></v-divider>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12">
                            <v-textarea v-model="comments" label="Observações" />
                        </v-col>
                        <!--  <v-col cols="6">
                            <v-switch
                                v-model="signed_contract"
                                color="primary-blue"
                                label="Contrato assinado"
                            ></v-switch>
                        </v-col>
                        
                        <v-col v-if="status === 'A'" cols="12">
                            <v-switch
                                v-model="next_session_mounted"
                                color="primary-blue"
                                label="Próxima atendimento estruturada?"
                            ></v-switch>
                        </v-col> -->
                    </v-row>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-row no-gutters justify="space-between">
                    <v-col cols="auto">
                        <v-btn :disabled="loading" :loading="loading" color="secondary" outlined elevation="0" @click="close"><v-icon left>mdi-window-close</v-icon> Cancelar</v-btn>
                    </v-col>
                    <v-col cols="auto">
                        <v-btn
                            :disabled="loading"
                            :loading="loading"
                            dark 
                            color="primary" 
                            elevation="0" 
                            @click="submitForm"
                        >
                            {{ !customer_checked ? 'Verificar cliente' : 'Salvar' }} <v-icon right>mdi-check-bold</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import dayjs from "dayjs";
dayjs.extend(require('dayjs/plugin/customParseFormat'));
import { mapActions } from 'vuex';

export default {
    props: {
        value: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            customer_checked: false,
            customer_data: null,
            show: this.value,
            basic_rules: {
                required: value => !!value || "Informação obrigatória",
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return pattern.test(value) || 'Email inválido'
                }
            },
            /* show_datepicker: false, */
            show_datepicker_birthday: false,
            loading: false,
            error_message: null,
            alert_message: null,
            success_message: null,
            name: null,
            cpf: null,
            rg: null,
            email: null,
            phone: null,
            status: "P",
            /* signed_contract: false,
            ammount: null,
            payment_type: "M",
            payday: null, */
            birthday: null,
            /* payment_frequency: "M",
            week_day_session: null,
            session_frequency: "S",
            session_duration: 50, */
            comments: null,
            /* show_timepicker: false,
            show_timepicker_session: false,
            hour_session: null,
            hour_next_session: null,
            show_next_session: false,
            next_session: null,
            payer_name: null,
            payer_cpf: null,
            equal_payer: true, */
            balance: 0,
            /* next_session_mounted: false */
        };
    },
    watch: {
        value() {
            this.show = this.value;
        },
        show() {
            this.error_message = null;
            this.alert_message = null;
            this.customer_checked = false;
            this.customer_data = null;
            this.success_message = null;
            this.$emit("input", this.show);
        },
        signed_contract(new_value) {
            if (new_value) {
                this.status = 'A';
            }
        },
        email() {
            if (this.customer_checked) {
                this.customer_checked = false;
            }
        }
    },
    methods: {
        ...mapActions("customers", ["ActionDoCreateCustomer", "ActionDoGetCustomers", "ActionDoCheckCustomerExists"]),
        formatDate(date) {
            return date ? dayjs(date).format("DD/MM/YYYY") : null;
        },
        formatUsa(date) {
            if (date) {
                if (date.length === 8) {
                    return dayjs(date, 'DDMMYYYY').format('YYYY-MM-DD');
                } else if (date.length === 10) {
                    return dayjs(date, 'DD/MM/YYYY').format('YYYY-MM-DD');
                }
            }

            return null;
        },
        close() {
            this.$refs.formCustomer.reset();
            this.show = false;
        },
        submitForm() {
            if (this.customer_checked) {
                this.save();
            } else {
                this.checkCustomer();
            }
        },
        checkCustomer() {
            this.loading = true;
            this.error_message = null;
            this.success_message = null;
            this.customer_checked = false;
            this.customer_data = null;

            if (this.$refs.formCustomer.validate()) {
                this.ActionDoCheckCustomerExists({
                    email: this.email
                }).then(response => {
                    this.customer_checked = true;

                    if (response.exists) {
                        if (response.already_customer) {
                            this.error_message = "Este email já está cadastrado como um cliente seu";
                            this.customer_checked = false;
                            this.customer_data = null;
                            return;
                        }
                        this.success_message = "Dados do cliente encontrados";
                        this.customer_data = response.customer;

                        this.name = this.customer_data.name;
                        this.cpf = this.customer_data.cpf;
                        this.rg = this.customer_data.rg;
                        this.phone = this.customer_data.phone;
                        this.birthday = this.customer_data.birthday;
                    } else {
                        this.alert_message = "Cliente não encontrado, você deve preencher as informações abaixo";
                        this.customer_data = null;
                    }
                    this.loading = false;
                }).catch(error => {
                    console.error(error);
                    this.error_message = error.response.data;
                    this.customer_checked = false;
                })
            } else {
                this.loading = false;
            }
        },
        save() {
            this.loading = true;
            this.error_message = null;
            this.success_message = null;

            if (this.$refs.formCustomer.validate()) {

                let payload = {};
                if (this.customer_data) {
                    payload = {
                        customer_id: this.customer_data.id,
                        status: this.status,
                        comments: this.comments,
                        balance: this.balance !== 0 ? parseInt(this.balance?.replaceAll(".", "")) : this.balance,
                    };
                } else {
                    payload = {
                        name: this.name,
                        cpf: this.cpf,
                        rg: this.rg,
                        email: this.email,
                        phone: this.phone,
                        birthday: this.birthday,
                        status: this.status,
                        comments: this.comments,
                        balance: this.balance !== 0 ? parseInt(this.balance?.replaceAll(".", "")) : this.balance,
                    };

                     /* ammount: this.ammount?.replaceAll(".", ""),
                        payment_type: this.payment_type, */
                        /* signed_contract: this.signed_contract,
                        payday: this.payday,
                        payment_frequency: this.payment_frequency,
                        session_frequency: this.session_frequency,
                        week_day_session: this.week_day_session,
                        session_duration: this.session_duration,
                        hour_session: this.hour_session,
                        next_session: null, */
                        /* payer_name: this.payer_name,
                        payer_cpf: this.payer_cpf, */
                        /* next_session_mounted: this.next_session_mounted */
                }

                this.ActionDoCreateCustomer(payload).then(response => {
                    this.ActionDoGetCustomers();

                    if (response.customer_id) {
                        this.success_message = "Cliente adicionado com sucesso";
                        this.$refs.formCustomer.reset();
                        this.loading = false;
                        this.$emit("created");
                        this.show = false;
                    } else {
                        this.error_message = "Houve um erro ao cadastrar o cliente";
                        this.loading = false;
                    }
                }).catch(error => {
                    console.error(error);
                    this.error_message = error.response.data;
                    this.loading = false;
                });
            } else {
                this.loading = false;
            }
        }
    }
};
</script>
